import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ReactComponent as GoToIcon } from '../../assets/goto.svg';
import * as Styled from './GoToCertificateButton.styles';

interface GoToCertificateButtonProps {
  documentBlockchainAddress?: string;
  isLoading?: boolean;
}

const GoToCertificateButton = ({
  documentBlockchainAddress = '',
  isLoading = false,
}: GoToCertificateButtonProps) => {
  const { t } = useTranslation();

  return (
    <Link to={`/home/certificates/${documentBlockchainAddress}`}>
      <Styled.Button type="text" icon={<GoToIcon />} loading={isLoading}>
        {t('nav.goTo')}
      </Styled.Button>
    </Link>
  );
};

export default GoToCertificateButton;
